export default function formatPlanPercentage(
  value: number | undefined | null
): number {
  if (!value || value < 0) return 0;
  if (value > 1) return 100;

  return Math.round(value * 100);
}
